module.exports = __webpack_public_path__ + "static/media/mobile.6ec9e9604a.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/mobile.png
// module id = 6425
// module chunks = 0